var render, staticRenderFns
import script from "./DocumentsManage.vue?vue&type=script&lang=js&"
export * from "./DocumentsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/classleasingtraffic.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df09dbb')) {
      api.createRecord('0df09dbb', component.options)
    } else {
      api.reload('0df09dbb', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/Backend/DocumentsManage.vue"
export default component.exports